import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { BushelSummaryReportFilters, useDownloadSummaryData } from "@/lib/api/otc";
import { BearDatePicker } from "../ContractForm";
import { ReportCard, ReportDownloadLink } from "./ReportCard";

/**
 * Summary Report — optional as-of date. Generate downloads a single link.
 */
export function SummaryReportCard() {
  const { toast } = useToast();
  const downloadDataLinkFunc = useDownloadSummaryData();
  const [filters, setFilters] = useState<BushelSummaryReportFilters>({});
  const [link, setLink] = useState<string | undefined>(undefined);
  const [isDownloading, setIsDownloading] = useState(false);

  const onGenerate = async () => {
    if (isDownloading) return;
    // Clear any prior result for this report before running again.
    setLink(undefined);
    setIsDownloading(true);

    const result = await downloadDataLinkFunc(filters);

    if (!result.success) {
      toast({ title: "Failed to generate", description: "" });
    } else {
      setLink(result.data.link);
    }

    setIsDownloading(false);
  };

  return (
    <ReportCard
      title="Summary Report"
      description="Generate a summary report across all OTC contracts."
      isDownloading={isDownloading}
      onGenerate={onGenerate}
      hasResults={!!link}
      linkContent={link ? <ReportDownloadLink href={link} label="Download Report" /> : null}
    >
      <div className="grid grid-cols-1 gap-3">
        <BearDatePicker
          tabIndex={0}
          name="summary_report_as_of"
          label="As Of Date"
          value={filters.as_of}
          onValueChange={(date: Date | undefined) =>
            setFilters((previous: BushelSummaryReportFilters) => ({ ...previous, as_of: date }))
          }
        />
      </div>
    </ReportCard>
  );
}
